/**
 * Shared, pure coupon arithmetic (issue #596 Contracts pinned "Discounted
 * figure"). Extracted from `PaymentDetailsComponent.applyCoupon()` /
 * `discountedPayment()` (behaviour-preserving — same operations, same
 * rounding order) so `/pricing` and the payment page can never compute a
 * different discounted figure for the same (coupon, price) pair.
 */
export interface CouponAmounts {
  percent_off_precise?: number | null;
  amount_off?: number | null;
}

/**
 * The discount amount a coupon applies to a given price, in dollars, rounded
 * to cents — a percentage coupon multiplies `price`, an amount-off coupon is
 * already in cents from Stripe. Matches
 * `PaymentDetailsComponent.applyCoupon()` exactly.
 */
export function couponDiscountAmount(coupon: CouponAmounts, price: number): string {
  const percentOff = coupon?.percent_off_precise;
  return percentOff !== null && percentOff !== undefined
    ? ((percentOff / 100) * price).toFixed(2)
    : ((coupon?.amount_off ?? 0) / 100).toFixed(2);
}

/**
 * `price` minus `discount`, floored at $0 — matches
 * `PaymentDetailsComponent.discountedPayment()` exactly.
 */
export function applyDiscount(price: number, discount: number | string): string {
  return Math.max(0, price - Number(discount)).toFixed(2);
}
